import { render } from "./_fancy-info.vue?vue&type=template&id=0338df41"
import script from "./_fancy-info.vue?vue&type=script&lang=js"
export * from "./_fancy-info.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__